import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { ComponentErrorBoundary } from '@app/utilities';

export function CalendarTypes({
  selectedCalendarType,
  setSelectedCalendarType,
}: {
  selectedCalendarType: string;
  setSelectedCalendarType: Dispatch<SetStateAction<string>>;
}) {
  const calendarTypes = useMemo(() => ['BACS', 'SEPA'], []);
  useEffect(() => {
    if (!selectedCalendarType) {
      setSelectedCalendarType(calendarTypes[0]);
    }
  }, [calendarTypes, selectedCalendarType, setSelectedCalendarType]);
  return (
    <ComponentErrorBoundary>
      <div className={'ui selection list'}>
        {/* TODO: Can make this a scrollable list if gets too large */}
        {calendarTypes?.map((calendarType) => (
          <div
            key={calendarType}
            className={calendarType === selectedCalendarType ? 'active item' : 'item'}
            onClick={() => setSelectedCalendarType(calendarType)}>
            {calendarType}
          </div>
        ))}
      </div>
    </ComponentErrorBoundary>
  );
}
